import { render } from "./DocumentReportOrigin.vue?vue&type=template&id=2ea2ee22&scoped=true&ts=true"
import script from "./DocumentReportOrigin.vue?vue&type=script&lang=ts"
export * from "./DocumentReportOrigin.vue?vue&type=script&lang=ts"

import "./DocumentReportOrigin.vue?vue&type=style&index=0&id=2ea2ee22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea2ee22"]])

export default __exports__